import { render, staticRenderFns } from "./OurPriceSection.vue?vue&type=template&id=06ad9c2a&scoped=true&"
import script from "./OurPriceSection.vue?vue&type=script&lang=js&"
export * from "./OurPriceSection.vue?vue&type=script&lang=js&"
import style0 from "./OurPriceSection.vue?vue&type=style&index=0&id=06ad9c2a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad9c2a",
  null
  
)

export default component.exports